import React, { useState } from "react";
import { styled } from "../../stitches.config";
import { parseISO, getTime, differenceInSeconds } from "date-fns";
import { CSSTransition } from "react-transition-group";

import CircleButton from "../CircleButton";
import { useInterval } from "../../helpers/useInterval";
import { useWindowWidth } from "../../helpers/useWindowWidth";
import { useHover } from "../../helpers/useHover";
import { h3, h4, } from "../../redesign/commonStyles/Fonts";
import Link from "../Link";
import { mainColor } from "../../stitches.config";

import facebook from "../../assets/img/facebook_black.svg";
import twitter from "../../assets/img/twitter_black.svg";

interface IData {
  amount: number;
  reqAmount: number;
  amountNaTemat: number;
  finished: boolean;
  endDate: string;
}

interface IPartnerInfo {
  partner: string;
  partnerInfo: string;
  partnership?: string;
  partnershipLogoUrl?: string;
}

interface ICountdown {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

type TParagraphProps = {
  color?: string;
  colorSecondary?: string;
  fontSizePrimary: number;
  fontSizeSecondary?: number;
};

interface IStyled {
  theme?: any;
}
interface IWrap extends IStyled {
  variant: string;
  isSummary?: boolean;
  finished?: IData["finished"];
  isBridPaymentModalOpen?: boolean;
}
interface IPWrap {
  variant: string;
}

interface IProgressBar extends IStyled {
  fixedProgress: number;
  progress: number;
}

const BridDonationProgress: React.FC<{
  blockData: IData;
  targetArticleLink?: string;
  partner: IPartnerInfo;
  setShowModal?: (value: boolean) => void;
  isSummary?: boolean;
  isBridPaymentModalOpen?: boolean;
  payForm?: () => React.ReactNode;
}> = ({ blockData, partner = {}, setShowModal, targetArticleLink, isSummary, isBridPaymentModalOpen, payForm }) => {
  const { amount, reqAmount, amountNaTemat, finished, endDate } = blockData;
  const { partner: partnerName = "naTemat.pl", partnerInfo = "", partnership = "", partnershipLogoUrl = "", } = partner;
  const width: number = useWindowWidth();
  const [hoverRef, isHovered] = useHover();
  const [countdown, setCoundown] = useState<ICountdown>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });

  const parsed: number = getTime(parseISO(endDate));

  const formatDate = (
    diff: number
  ): { days: number; hours: number; minutes: number; seconds: number } => {
    let seconds = diff;
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    let days = Math.floor(hours / 24);

    hours %= 24;
    minutes %= 60;
    seconds %= 60;

    return {
      days,
      hours,
      minutes,
      seconds,
    };
  };

  useInterval(
    () => {
      const now = getTime(Date.now());
      const diff = differenceInSeconds(parsed, now);
      const dateObj = formatDate(diff);
      setCoundown(dateObj);
    },
    finished ? null : 1000
  );

  const progress: number = Math.round((amount / reqAmount) * 100) || 0;
  const partnerFixedProgress: number =
    Math.round((amountNaTemat / reqAmount) * 100) || 0;

  return (
    <Wrap className={isBridPaymentModalOpen ? "brid-donation-progress" : ""} 
      // finished={finished}
      isNatemat={partnerName=="naTemat.pl"} 
      isSummary={isSummary}>
      {/* <S.H3>Wpłaty</S.H3> */}
      <PWrap /*variant={partnerName}*/>
        {/* <P1 fontSizePrimary={12} fontSizeSecondary={22}>
          <b>{progress}% </b>zostało osiągnięte
        </P1> */}
        {/* {width 6 || ( */}
        <HeadingAmount className="heading-amount">
          {partnerName === "naTemat.pl" ? (
            <>
              <h2>{amount} zł</h2>{" "}
              <h4 className={h4()}>
                <b>z {reqAmount} zł</b>
              </h4>
            </>
          ) : (
            <Heading className={h3()}>{partnerName}</Heading>
          )}
        </HeadingAmount>

        {partnerName === "naTemat.pl" ? (
          <>
            <ProgressBar
              css={{
                "$$fixedProgress": `${partnerFixedProgress}%`,
                "$$progress": `${progress - partnerFixedProgress}%`
              }}
            />
            <Contributions>
              <Contribution contribution="naTemat">
                <p>Wkład naTemat </p>
              </Contribution>
              <Contribution contribution="readers">
                <p>Wkład czytelników</p>
              </Contribution>
            </Contributions>

            {finished ? <Line /> : payForm && payForm()}

            <Status className="status">
              {finished ? (
                <>
                  <p>Zbiórka została zakończona.</p>
                  {targetArticleLink ?
                    <BridArticleLink>
                      <p>Mareriał już jest!</p>
                      <Link to={targetArticleLink}>Czytaj artykuł</Link>
                    </BridArticleLink>
                    :
                    <p>Materiał jest już w realizacji.</p>
                  }
                </>
              ) : (
                <>
                  <p>Do końca zbiórki:</p>
                  <p>
                    {countdown.days} {countdown.days === 1 ? "dzień" : "dni"}{" "}
                    {countdown.hours} godz{" "}
                    {width < 996 || (
                      <>
                        {countdown.minutes} min {countdown.seconds}s{" "}
                      </>
                    )}
                  </p>
                </>
              )}
            </Status>
          </>
        ) : (
          <>
            {partnershipLogoUrl ?
              <WrapperPartnerLogo>
                <img src={partnershipLogoUrl} />
              </WrapperPartnerLogo>
              : null
            }
          </>
        )}

        {/* <Paragraph
          fontSizePrimary={12}
          color="#737373"
          colorSecondary="#737373"
        >
          <b>Do końca: </b>
          <TimeLeft>
            {finished ? (
              "Zakończony"
            ) : (
              <React.Fragment>
                {countdown.days} {countdown.days === 1 ? "dzień" : "dni"}{" "}
                {countdown.hours} godz{" "}
                {width < 996 || (
                  <React.Fragment>
                    {countdown.minutes} min {countdown.seconds}s{" "}
                  </React.Fragment>
                )}
              </React.Fragment>
            )}
          </TimeLeft>
        </Paragraph> */}
      </PWrap>
      {/* {width < 996 && (
        <MobileBar>
          <img src={facebook} alt="fb icon" />
          <img src={twitter} alt="twitter icon" />
          <CircleButton disabled={finished} onClick={() => setShowModal(true)}>
            {finished ? "Zakończone" : "Wesprzyj projekt"}
          </CircleButton>
        </MobileBar>
      )} */}
      {/* <span ref={hoverRef}>wkład {partnerName}</span> */}
      <CSSTransition
        in={isHovered}
        timeout={300}
        classNames="modal"
        mountOnEnter
        unmountOnExit
      >
        <Modal>
          <b>Wkład {partnerName}</b>
          <p>{partnerInfo}</p>
        </Modal>
      </CSSTransition>
    </Wrap>
  );
};

const Status = styled("div", {
  position: "relative",
  display: "block",
  textAlign: "center",
  width: "100%",
  zIndex: 2,
  "p": {
    color: "#8d8d8d",
    fontSize: "14px",
    margin: "0",
    "&:last-child": {
      color: "#f5f5f5"
    }
  }
});

const BridArticleLink = styled("div",{
  "p":{
    color: "white"
  },
  "a":{
    width: "100% !important",
    backgroundColor: "#ff6400 !important",
    margin: 0,
    marginTop: "16px",
    padding: "20px 0",
    display: "block",
    fontWeight: 600,
    "&:hover": {
      color: "white",
      textDecoration: "none"
    }
  }
});

const Modal = styled("div", {
  position: "absolute",
  top: "177px",
  left: "-14px",
  width: "296px",
  minHeight: "166px",
  boxShadow: "0 1px 8px 0 rgba(110, 110, 110, 0.1)",
  backgroundColor: "#ffffff",
  b: {
    display: "inline-block",
    color: "$primary",
    fontSize: "14px",
    marginTop: "30px",
    marginLeft: "33px",
    fontWeight: 500
  },
  p: {
    margin: "5px 33px",
    fontSize: "12px",
    fontWeight: 300,
    color: "#737373"
  },
  "&.modal-enter": {
    opacity: 0
  },
  "&.modal-enter-active": {
    opacity: 1,
    transition: "opacity 300ms"
  },
  "&.modal-exit": { opacity: 1 },
  "&.modal-exit-active, &.modal-exit-done": {
    opacity: 0,
    transition: "opacity 300ms"
  }
});

const MobileBar = styled("div", {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  paddingBottom: "15px",
  "img": {
    width: "27px",
    height: "27px",
    marginLeft: "26px"
  },
  ".learn-more": {
    display: "block",
    width: "15em !important",
    fontSize: "14px",
    marginRight: "20px",
    marginLeft: "auto"
  }
});

const Paragraph = styled("p",{
  margin: "5px 0",
  color: "$$color",
  fontSize: "$$fontSizePrimary",
  "b": {
    color: "$$colorSecondary",
    fontSize: "$$fontSizeSecondary",
  },
  "@bp4":{
    whiteSpace: "nowrap"
  }
});
// });emotionStyled.p<TParagraphProps>`
//   margin: 5px 0;
//   //color: ${(props) => props.color || "#272424"};
//   //font-size: ${(props) => props.fontSizePrimary}px;
//   b {
//     color: ${(props) => props.colorSecondary || "#272424"};
//     font-size: ${(props) => props.fontSizeSecondary || props.fontSizePrimary}px;
//   }
//   @media (min-width: 996px) {
//     white-space: nowrap;
//   }
// `;
const HeadingAmount = styled("div", {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "baseline",
  width: "100%",
  "h2,  h3": {
    lineHeight: "42px"
  },
  h2: {
    color: "#fff",
    margin: "0",
    marginRight: "8px",
    fontFamily: "$grotesk",
    fontSize: "38px",
    fontWeight: 700
  }
});
const Contributions = styled("div", {
  display: "flex",
  justifyContent: "space-between",
  marginTop: "16px",
  width: "100%"
});
const Contribution = styled("div", {
  display: "flex",
  p: {
    color: "#CCCCCC",
    margin: "0",
    fontSize: "14px",
  },
  "&:before": {
    content: "",
    width: "12px",
    height: "12px",
    borderRadius: "3px",
    marginRight: "8px",
    marginTop: "3px",
  },
  variants: {
    contribution: {
      naTemat: {
        "&:before": {
          backgroundColor: "$primary",
        },
      },
      readers: {
        "&:before": {
          backgroundColor: "#fff",
        },
      },
    },
  },
});

const Heading = styled("div", {
  margin: "0 0 32px 0",
  color: "#131212"
});

const Line = styled("div", {
  width: "100%",
  height: "1px",
  display: "block",
  backgroundColor: "#fff",
  margin: "32px 0",
  opacity: 0.1
});

const P1 = styled(Paragraph, {
  margin: "1px 0",
  "@bp4": {
    fontSize: "16px",
    margin: "5px 0",
    "b": {
      fontSize: "28px"
    }
  }
});

const TimeLeft = styled("span", {
  color: "#ed2024",
  "@bp4": {
    color: "inherit",
    display: "inline-block",
    width: "160px",
    maxWidth: "160px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    height: "12px"
  }
});

const PWrap = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "center",
  /* padding: ${({ variant }) =>
    variant === `naTemat.pl` ? "32px 24px 40px 24px" : "25px"}; */
  "form": {
    width: "100%"
  },
  "@bp4": {
    alignItems: "flex-end",
    margin: 0,
    display: "block"
  }
});

const ProgressBar = styled("div", {
  position: "relative",
  width: "100%",
  height: "6px",
  borderRadius: "5px 0 0 5px",
  margin: "0px 20px",
  backgroundColor: "rgba(255, 255, 255, 0.1)",
  "&:before": {
    content: "",
    position: "absolute",
    top: "0",
    left: "0",
    height: "4px",
    borderRadius: "5px 0 0 5px",
    backgroundColor: "$primary",
    border: "3px solid",
    borderColor: "$primary",
    width: "$$fixedProgress"
  },
  "&:after": {
    height: "4px",
    borderRadius: "0 5px 5px 0",
    backgroundColor: "#fff",
    border: "3px solid #fff",
    content: "",
    position: "absolute",
    top: "0",
    left: "$$fixedProgress",
    maxWidth: "calc(100% - $$fixedProgress)",
    width: "$$progress"
  },
  "@bp4": {
    width: "100%",
    margin: "0"
  }
});

const WrapperPartnerLogo = styled("div", {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #e7e7e7",
  width: "100%",
  padding: "48px 0",
  "@bp4": {
    width: "auto",
    padding: "48px 104px"
  },
  "img": {
    maxWidth: "200px"
  }
});

const Wrap = styled("div", {
  /* position: fixed; */
  /* border-radius: 20px 20px 0 0; */
  boxShadow: "0 -8px 8px 0 rgba(110, 110, 110, 0.1)",
  padding: "16px 40px",
  width: "100%",
  left: "0",
  bottom: "0",
  zIndex: 16,
  margin: "0 auto",
  backgroundColor: "#fff",
  "& > span": {
    display: "none",
    position: "relative",
    cursor: "pointer"
  },
  "@bp5": {
    /* position: absolute; */
    /* height: ${({ finished, isSummary }) =>
    isSummary ? "auto" : finished ? "293px" : "430px"}; */
    /* top: 327px; */
    /* right: 2%; */
    marginTop: "-200px",
    width: "100%",
    top: "40px",
    left: "unset",
    padding: "48px",
    position: "sticky",
    boxShadow: "none",
    borderRadius: "0",
    "& > span": {
      display: "inline",
      fontSize: "10px",
      color: "$primary"
    }
  },
  variants: {
    "isNatemat": {
      true: {
        backgroundColor: "#000"
      },
      false: {}
    },
    "isSummary": {
      true: {
        "@bp5":{
          marginTop: "0",
          top: "190px",
          left: "0"
        }
      },
      false: {}
    }
  }
});

export default BridDonationProgress;
